<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subjects In Progress of Enrollment
      </h2>
      <p class="tw-italic tw-text-gray-700" v-if="totalItems > 0">
        {{ totalItems }} Subjects in Progress
      </p>
    </b-container>

  <b-container fluid>
    <b-row style="padding: 10px;">
    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="myProvider"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:cell(consent_on_hold)="data">
          <span v-if="data.item.consent_on_hold == 'Yes'">Consent On Hold</span>
          <span v-if="data.item.consent_on_hold != 'Yes'">No Show</span>
      </template>
    </b-table>

    <b-pagination
      v-if="options.totalRows"
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </b-row>
  </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 10,
        perPage: 20
      },
      loading: false,
      search: "",
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      subject_enrollment: "Enrolled",
    };
  },
  computed: {},
  watch: {
    subject_enrollment: function() {
      this.$refs.table.refresh();
    }
  },
  methods: {
    myProvider(ctx) {
      const that = this;

      return HTTP.get("/kenya/metrics/subjects-enrolled", {
        params: {
          subject_enrollment: that.subject_enrollment,
          page: ctx.currentPage,
          count: ctx.perPage,
          sortBy: that.sortBy,
          sortDesc: that.sortDesc ? "" : "yes"
        }
      })
        .then(response => {
          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
          });
          that.fields = fields;

          that.data = response.data.data;
          that.totalItems = response.data.total;
          // that.fields = response.data.fields;
          that.options.totalRows = parseInt(response.data.total);
          return that.data;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          return [];
        });
    }
  }
};
</script>

<style></style>
